import { render, staticRenderFns } from "./form-password.vue?vue&type=template&id=8389c16c"
import script from "./form-password.vue?vue&type=script&lang=js"
export * from "./form-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports